package one.healthium.insights.data.sources.storage

import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.map
import one.healthium.db.dao.SavedContentDao
import one.healthium.db.dao.SavedContentType
import one.healthium.insights.data.mapper.SavedContentMapper
import one.healthium.insights.domain.models.SavedContentModel
import one.healthium.insights.domain.models.SavedContentOptions

class SavedContentStorage(
    private val savedContentDao: SavedContentDao,
    private val savedContentMapper: SavedContentMapper,
) {
    fun getFavorites(): Flow<List<SavedContentModel>> {
        return savedContentDao.get(SavedContentType.Favorite)
            .map { it.mapNotNull(savedContentMapper::entityToModel) }
    }

    fun getRecently(): Flow<List<SavedContentModel>> {
        return savedContentDao.get(SavedContentType.Recently)
            .map { it.mapNotNull(savedContentMapper::entityToModel) }
    }

    suspend fun addFavorite(options: SavedContentOptions) {
        savedContentDao.insert(savedContentMapper.optionsToEntity(options, SavedContentType.Favorite))
    }

    suspend fun addRecently(options: SavedContentOptions) {
        savedContentDao.insert(savedContentMapper.optionsToEntity(options, SavedContentType.Recently))
    }

    suspend fun remove(id: String) {
        savedContentDao.deleteById(id)
    }

    suspend fun deleteOldRecentlyEntries() {
        savedContentDao.deleteOldRecentlyEntries()
    }
}